import get from "lodash.get";

export const selectInactivityLogoutTimeout = state => {
  const timeInMinutes = get(
    state,
    "preferences.settings.Privacy.AutoTimeout",
    null
  );

  if (timeInMinutes === null) return null;

  return parseInt(timeInMinutes, 10) * 60 * 1000;
};
